<template>
  <table class="table table-sm border">
    <thead class="thead-light">
      <th class="w-50 pr-3">Port Of Loading</th>
      <th class="w-50 px-3">Port Of Discharge</th>
      <th v-if="!isDetail" style="min-width: 40px" class="text-center"
        ><i class="fas fa-plus cursor-pointer" @click="addPort"></i
      ></th>
    </thead>
    <tbody>
      <tr v-for="(port, index) in form.ports" :key="index">
        <td class="w-50 pr-3 py-2 align-top">
          <template v-if="!isDetail">
            <b-form-select v-model="port.pol" :options="polOptions" plain />
            <b-form-input
              class="mt-2"
              v-if="port.pol == 'other'"
              v-model="port.polOther"
              plain
            />
          </template>
          <template v-else>
            <p class="form-control-plaintext mb-0">
              {{
                port.pol === 'other'
                  ? port.polOther || '-'
                  : polOptions.find((opt) => opt.value === port.pol)?.text ||
                    port.pol ||
                    '-'
              }}
            </p>
          </template>
        </td>
        <td class="w-50 pl-3 py-2 align-top">
          <template v-if="!isDetail">
            <b-form-select v-model="port.pod" :options="podOptions" plain />
            <b-form-input
              class="mt-2"
              v-if="port.pod == 'other'"
              v-model="port.podOther"
              plain
            />
          </template>
          <template v-else>
            <p class="form-control-plaintext mb-0">
              {{
                port.pod === 'other'
                  ? port.podOther || '-'
                  : podOptions.find((opt) => opt.value === port.pod)?.text ||
                    port.pod ||
                    '-'
              }}
            </p>
          </template>
        </td>
        <td v-if="!isDetail" class="text-center">
          <i
            @click="handleDeletePort(index)"
            class="fas fa-trash-alt text-danger cursor-pointer"
          ></i>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    polOptions: {
      type: Array,
      required: true,
    },
    podOptions: {
      type: Array,
      required: true,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    addPort() {
      this.form.ports.push({ pol: null, polOther: '', pod: null, podOther: '' })
    },
    handleDeletePort(index) {
      this.form.ports.splice(index, 1)
    },
  },
}
</script>
